// src/index.js
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';

// Import all CSS files
import './styles.css'; // or styles.css
import './styles/header.css';
import './styles/hero.css';
import './styles/publications.css';
import './styles/projects.css';
import './styles/courses.css';
import './styles/detail-pages.css';
import './styles/responsive.css';
import './styles/about.css';
import './styles/footer.css';
import './styles/main.css';
import './styles/contact.css';
import './styles/services.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter basename="/">
      <App />
    </BrowserRouter>
  </React.StrictMode>
);

// Add to src/index.js
document.addEventListener('contextmenu', (e) => {
  if (e.target.closest('.markdown-content')) {
    e.preventDefault();
    alert('Content is copyright protected. Please contact for permissions.');
  }
});

// Prevent keyboard shortcuts for copy
document.addEventListener('keydown', (e) => {
  // Ctrl+C or Cmd+C
  if ((e.ctrlKey || e.metaKey) && e.key === 'c') {
    if (document.activeElement.closest('.markdown-content')) {
      e.preventDefault();
      alert('This content is copyright protected. Please contact for permissions.');
    }
  }
});